import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CustomCursor from '../CustomCursor';
import Footer from '../Footer';
import Header from '../Header';
import { getLanguageFromPath, localizePath } from '../../helper/localizedPath';

export default function Layout({ headerVariant }) {
  const { i18n } = useTranslation();
  const location = useLocation();
  const currentLanguage = getLanguageFromPath(location.pathname, i18n.language);
  const canonicalPath = localizePath(location.pathname, currentLanguage);
  const canonicalUrl = `https://www.stablerecords.cz${canonicalPath === '/' ? '' : canonicalPath}`;
  const csUrl = `https://www.stablerecords.cz${localizePath(location.pathname, 'cs') === '/' ? '' : localizePath(location.pathname, 'cs')}`;
  const enPath = localizePath(location.pathname, 'en');
  const enUrl = `https://www.stablerecords.cz${enPath === '/' ? '' : enPath}`;

  useEffect(() => {
    if (i18n.language !== currentLanguage) {
      i18n.changeLanguage(currentLanguage).then(() => {
        window.scrollTo(0, 0);
      });
    } else {
      window.scrollTo(0, 0);
    }
    document.documentElement.lang = currentLanguage;
  }, [currentLanguage, i18n]);

  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <link rel="alternate" hrefLang="cs" href={csUrl} />
        <link rel="alternate" hrefLang="en" href={enUrl} />
        <link rel="alternate" hrefLang="x-default" href={csUrl} />
      </Helmet>
      <Header variant={headerVariant} />
      <Outlet />
      <CustomCursor />
      <Footer />
    </>
  );
}
